export default "__VITE_ASSET__8c7e6f09__"